module.exports = __webpack_public_path__ + "static/media/AS_icon_lightbulb.6c90bb2f.svg";